import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { GiShare } from "react-icons/gi";
import { QRCode } from "react-qrcode-logo";
import qrCodeBorder from "../../assets/images/qr-code-border.svg";
import { SHARE_QR } from "../../utils/constants/common";
import qrCodeLogo from "../../assets/images/sidebar_icons/logoIcon.png";
import uploadQrLogo from "../../assets/images/function_page_icons/camera.svg";
import removeQrLogo from "../../assets/images/function_page_icons/nocamera.svg";
import crossicon from "../../assets/images/global_icons/crossicon.svg";
import ImageUploadSquare from "../../components/ImageUploadSquare";
import { BsImageFill } from "react-icons/bs";
import baseUrl from "../../utils/constants/baseUrl";
import showToast from "../../helpers/showToast";
import { CUSTOMIZE_QRCODE, IMAGE_UPLOAD } from "../../utils/constants/apiUrl";
import { loggedInUser, teamIDCheck } from "../../utils/store";
import { useAtom } from "jotai";
import { post } from "../../server";
import { trackEvent } from "../../utils/mixpanel";
import { toPng } from "html-to-image";
const QRCodeModal = ({
  target,
  qrOpen,
  handleQRClose,
  setShowCopyPopup,
  handleDownload,
  qrCodeId,
  functionType,
  function_type,
  functionUuid,
  url,
  QRCodeCustomize,
  refreshData,
}) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loding, setLoading] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [image, selectImage] = useState("");
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [bgColor, setBgColor] = useState(
    QRCodeCustomize?.qr_bg_color || "#ffffff"
  );
  const [fgColor, setFgColor] = useState(
    QRCodeCustomize?.qr_front_color || "#000000"
  );
  const [QRLogo, setQRLogo] = useState(QRCodeCustomize?.qr_image || qrCodeLogo);
  const [QRCodeImage, setQRCodeImage] = useState(
    QRCodeCustomize?.qr_code_image
  );
  const handleEditModalOpen = () => {
    setEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
  };
  const handleUploadModalOpen = () => {
    setUploadModalOpen(true);
  };

  const handleUploadModalClose = () => {
    setUploadModalOpen(false);
  };

  // const handleQRLogoSave = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   if (image && typeof image == "object") {
  //     let formDataObj = new FormData();
  //     formDataObj.append("image_type", "card_logo");
  //     formDataObj.append("image", image);

  //     let { status, message, data } = await post(
  //       IMAGE_UPLOAD,
  //       formDataObj,
  //       Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //     );
  //     if (status) {
  //       setUploadedImageUrl(data);
  //       setQRLogo(uploadedImageUrl);
  //       setUploadModalOpen(false);
  //     } else {
  //       showToast(status, message);
  //       setLoading(false);
  //       return false;
  //     }
  //   }
  // };
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleQRLogoSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (image && typeof image === "object") {
      // convert uploaded file to base64
      const base64Logo = await toBase64(image);
      setQRLogo(base64Logo); // use this directly in <QRCode logoImage={QRLogo} />

      setUploadModalOpen(false);
      setLoading(false);
    }
  };
  const handleRemoveLogoImage = () => {
    setQRLogo("");
    setUploadedImageUrl("");
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    const qrCodeContainer = document.getElementById("qrCodeContainer");
    const childElement = qrCodeContainer.querySelector("#qr-code");
    const childELementDurl = childElement.toDataURL("image/png");
    const blob = await fetch(childELementDurl).then((res) => res.blob());

    let formDataObj = new FormData();
    formDataObj.append("image_type", "qr_code_image");
    const file = new File([blob], "qr_code_image.png", { type: "image/png" });
    formDataObj.append("image", file);
    let { status, message, data } = await post(
      IMAGE_UPLOAD,
      formDataObj,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setQRCodeImage(data);
      const payload = {
        id: QRCodeCustomize?.id,
        function_type:
          QRCodeCustomize?.function_type || QRCodeCustomize?.functionType,
        function_id: QRCodeCustomize?.function_id,
        qr_bg_color: bgColor,
        qr_front_color: fgColor,
        qr_image: QRLogo,
        qr_code_image: data,
      };
      let { status, message } = await post(
        CUSTOMIZE_QRCODE,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
      if (status) {
        showToast(status, message);
        await refreshData();
        handleQRClose(false);
      } else {
        showToast(status, message);
        setLoading(false);
        return false;
      }
    } else {
      showToast(status, message);
      setLoading(false);
      return false;
    }
    setEditModalOpen(false);
  };

  // const handleSave = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const qrCodeContainer = document.getElementById("qrCodeContainer");

  //     // Export the node as PNG
  //     const dataUrl = await toPng(qrCodeContainer, {
  //       cacheBust: true,
  //       useCORS: true,
  //     });
  //     const blob = await fetch(dataUrl).then((res) => res.blob());

  //     let formDataObj = new FormData();
  //     formDataObj.append("image_type", "qr_code_image");

  //     const file = new File([blob], "qr_code_image.png", { type: "image/png" });
  //     formDataObj.append("image", file);

  //     let { status, message, data } = await post(
  //       IMAGE_UPLOAD,
  //       formDataObj,
  //       Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //     );

  //     if (status) {
  //       setQRCodeImage(data);

  //       const payload = {
  //         id: QRCodeCustomize?.id,
  //         function_type:
  //           QRCodeCustomize?.function_type || QRCodeCustomize?.functionType,
  //         function_id: QRCodeCustomize?.function_id,
  //         qr_bg_color: bgColor,
  //         qr_front_color: fgColor,
  //         qr_image: QRLogo,
  //         qr_code_image: data,
  //       };

  //       let { status: saveStatus, message: saveMessage } = await post(
  //         CUSTOMIZE_QRCODE,
  //         payload,
  //         Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //       );

  //       if (saveStatus) {
  //         showToast(saveStatus, saveMessage);
  //         await refreshData();
  //         handleQRClose(false);
  //       } else {
  //         showToast(saveStatus, saveMessage);
  //       }
  //     } else {
  //       showToast(status, message);
  //     }
  //   } catch (err) {
  //     console.error("QR Save Error:", err);
  //     showToast(false, "Something went wrong while saving QR code");
  //   } finally {
  //     setLoading(false);
  //     setEditModalOpen(false);
  //   }
  // };

  const searchParams = new URLSearchParams(window.location.search);
  const dynamic_qr_code_id = searchParams.get("dynamic_qr_code");
  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  return (
    <>
      <Modal
        show={qrOpen}
        onHide={handleQRClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="customModal square-modal QRCodeModal"
        size="sm"
      >
        <Modal.Header className="modalHeader flex justify-end">
          <div className="modalGradientCircle"></div>
          <MdClose
            onClick={handleQRClose}
            className="modalCloseBtn flex justify-between"
          />
        </Modal.Header>
        <Modal.Body
          style={{ padding: "0" }}
          //className={`d-flex justify-content-center flex-column align-items-center`}
          className="text-center px-4 py-4"
        >
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="qrWrapper-team">
              {/* <img className="qrBorder" src={qrCodeBorder} alt="" /> */}
              {QRCodeCustomize && QRCodeCustomize?.qr_code_image !== null ? (
                <img
                  className="qrCodeImage"
                  src={baseUrl.PUBLIC_URL + QRCodeCustomize?.qr_code_image}
                  width="170px"
                  height="170px"
                  loading="lazy"
                  decoding="async"
                  alt=""
                  id={qrCodeId ? qrCodeId : "qr-code"}
                />
              ) : (
                <QRCode
                  value={
                    url ? url : `${SHARE_QR}${functionType}/${functionUuid}`
                  }
                  id={qrCodeId ? qrCodeId : "qr-code"}
                  logoImage={
                    QRCodeCustomize?.qr_image !== null
                      ? QRCodeCustomize?.qr_image
                      : baseUrl.PUBLIC_URL + qrCodeLogo
                  }
                  bgColor={
                    QRCodeCustomize?.qr_bg_color !== null
                      ? QRCodeCustomize?.qr_bg_color
                      : "#ffffff"
                  }
                  fgColor={
                    QRCodeCustomize?.qr_front_color !== null
                      ? QRCodeCustomize?.qr_front_color
                      : "#000000"
                  }
                  //logoPadding={3}
                  removeQrCodeBehindLogo
                  crossOrigin="anonymous"
                />
                // <p>adbghyja</p>
              )}
            </div>

            <h5 style={{ margin: "10px" }}>QR Code</h5>
            <p>Edit, Share or Download You QR Code</p>
          </div>
          <div className="row justify-content-center mx-0 px-3 gx-2 mobileViewWrapper mt-3">
            <div className="col-sm-6 text-center ">
              <Button
                variant="primary"
                className="editBtn w-100"
                ref={target}
                onClick={() => handleEditModalOpen({})}
              >
                Edit Qr Code
              </Button>
            </div>
            <div className="col-sm-6 text-center">
              <Button
                variant="primary"
                className="shareBtn d-block w-100"
                ref={target}
                onClick={() => {
                  setShowCopyPopup(true);
                  setTimeout(() => {
                    setShowCopyPopup(false);
                  }, 2000);
                  navigator.clipboard.writeText(
                    url ? url : `${SHARE_QR}${functionType}/${functionUuid}`
                  );
                }}
              >
                {/* <GiShare /> */}
                Share QR Code
              </Button>
            </div>
            {QRCodeCustomize && QRCodeCustomize?.qr_code_image !== null ? (
              <div className="col-12 text-center">
                <a
                  href={baseUrl.PUBLIC_URL + QRCodeImage}
                  download="qrcode.png"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() =>
                    trackEvent("QR Code Downloaded", {
                      function_type,
                      function_uuid: functionUuid,
                      dynamic_qr_code_id: dynamic_qr_code_id || null,
                      team_id: team_id || null,
                      user_id: user_id || null,
                      timestamp: new Date().toISOString(),
                      source: window.location.pathname,
                    })
                  }
                >
                  <Button className=" mt-2">Download QR Code</Button>
                </a>
              </div>
            ) : (
              <div className="customModalBtnWrapper btnWrapper">
                <button onClick={handleDownload}>Download QR</button>
              </div>
            )}
          </div>

          {/* <div className={`customModalBtnWrapper ${classes.btnWrapper}`}>
            <button onClick={handleDownload}>Download QR</button>
          </div> */}
        </Modal.Body>
      </Modal>

      <Modal
        show={editModalOpen}
        onHide={handleEditModalClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="customModal editQRModal square-modal QRCodeModal"
        size="sm"
      >
        <Modal.Header className="modalHeader">
          <div className="modalGradientCircle"></div>
          <MdClose onClick={handleEditModalClose} className="modalCloseBtn" />
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="qrWrapper">
              {/* <img className="qrBorder" src={qrCodeBorder} alt="" /> */}
              <div id="qrCodeContainer">
                <QRCode
                  value={
                    url ? url : `${SHARE_QR}${functionType}/${functionUuid}`
                  }
                  id={qrCodeId ? qrCodeId : "qr-code"}
                  logoImage={
                    uploadedImageUrl === ""
                      ? QRLogo
                      : baseUrl.PUBLIC_URL + uploadedImageUrl
                  }
                  bgColor={bgColor}
                  fgColor={fgColor}
                  logoPadding={3}
                  removeQrCodeBehindLogo
                  crossOrigin="anonymous"
                />
              </div>
            </div>
            <Button
              variant="primary"
              // className="saveBtn"
              ref={target}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="qrEditFooter">
          <ul className="list-unstyled m-0 w-100 ms-2">
            <li className="mb-3">
              <button
                className="uploadBtn border-0 bg-transparent"
                onClick={handleUploadModalOpen}
              >
                <img src={uploadQrLogo} alt="" className="img-fluid" />
              </button>
            </li>
            <li className="mb-3">
              <button
                className="removeImgBtn border-0 bg-transparent"
                onClick={handleRemoveLogoImage}
              >
                <img src={removeQrLogo} alt="" className="img-fluid" />
              </button>
            </li>
            <li className="mb-3">
              <Form.Group controlId="">
                <input
                  type="color"
                  className="colorPicker w-100"
                  value={bgColor}
                  onChange={(e) => setBgColor(e.target.value)}
                />
              </Form.Group>
            </li>
            <li>
              <Form.Group controlId="">
                <input
                  type="color"
                  className="colorPicker w-100"
                  value={fgColor}
                  onChange={(e) => setFgColor(e.target.value)}
                />
              </Form.Group>
            </li>
          </ul>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        className={`customModal uploadModal square-modal`}
        size="md"
        show={uploadModalOpen}
      >
        <Modal.Header className="mediaModalHeader modalHeader flex justify-end">
          <span>Upload</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleUploadModalClose}
          />
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <div className="text-center">
            <div className="d-flex justify-content-center align-items-center flex-column position-relative imageUpload mb-4">
              <ImageUploadSquare
                selectedImage={
                  typeof image == "object" ? image : baseUrl.PUBLIC_URL + image
                }
                setSelectedImage={selectImage}
              />
              <BsImageFill />
              <span>
                Drop your Images here, or <span>Browse</span>
              </span>
              <span>Support JPG, PNG, Only</span>
            </div>
            <Button
              variant="primary"
              className="saveBtn mb-3 mt-0"
              ref={target}
              onClick={handleQRLogoSave}
            >
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default QRCodeModal;
